module.exports = __webpack_public_path__ + "media/img/pages/companies/skyguide-80a40c63d74886a36d63884f2805016c.png";